"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variantSchema = exports.variantReferenceSchema = void 0;
const zod_1 = require("zod");
const variantKeySchema = zod_1.z
    .string()
    .trim()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
    .describe("Human-friendly unique key of a variant in the hyphen-separated lowercased format");
exports.variantReferenceSchema = zod_1.z.object({ key: variantKeySchema }).strict().describe("Reference to a variant of a calculator group");
exports.variantSchema = zod_1.z
    .object({
    key: variantKeySchema,
})
    .strict()
    .describe("Variant of a calculator");
